import createTaskProcessorWorker from "./createTaskProcessorWorker.js";
import Cartographic from "../Core/Cartographic.js"
import Transforms from "../Core/Transforms.js";
import defined from "../Core/defined.js";
import BoundingSphere from "../Core/BoundingSphere.js";
import Cartesian3 from "../Core/Cartesian3.js";
import Quaternion from "../Core/Quaternion.js";
import Matrix4 from "../Core/Matrix4.js";
import IndexDatatype from "../Core/IndexDatatype.js";
import Color from "../Core/Color.js";
import CesiumMath from "../Core/Math.js";
import Cartesian4 from "../Core/Cartesian4.js";

function calcTraceWallMesh(parameters, transferableObjects) {
  var traceWalls = parameters.traceWalls;
  //记录最大轨迹点数
  var MAXPOINTS_NUM_PRE_ALLPATH	=	5000;
  //目标临近多少点不抽稀
  var NO_SPARSE_PONITS_NUM	=	50;
   //抽稀轨迹最大点数
  var MAXPOINTS_NUM_PRE_SPARSEPATH = 300;
  var transformFunc = Transforms.localFrameToFixedFrameGenerator("north", "west");
  var scratchModelMat4 = new Matrix4();

  var length = traceWalls.length;
  var vertexWall = [];
  var vertexCount = 0;
  var indexCount = 0;

  for (var i=0; i<length; i++ ){
    if(defined(traceWalls[i]) && traceWalls[i].trackPoints.length > 1){
      var trackPoints = traceWalls[i].trackPoints;
      var verPts = [];
      //靠近目标的 NO_SPARSE_PONITS_NUM 点保留，抽稀其他点
      var ptLength = trackPoints.length;
      if(ptLength > MAXPOINTS_NUM_PRE_SPARSEPATH){
        var thiningCount = ptLength - NO_SPARSE_PONITS_NUM;
        var multiple = Math.floor(thiningCount / (MAXPOINTS_NUM_PRE_SPARSEPATH - NO_SPARSE_PONITS_NUM)) + 1;
        var sparseCount = ptLength-NO_SPARSE_PONITS_NUM-multiple;
        var index = 0;
        for(;index < sparseCount; index+=multiple){
          verPts.push({
            position:trackPoints[index].wcPosition,
          });
          var latLng = Cartographic.fromCartesian(trackPoints[index].wcPosition);
          var projGroundPos = Cartesian3.fromRadians(latLng.longitude, latLng.latitude);
          verPts.push({
            position:projGroundPos,
          });
          vertexCount+=2;
        }

        for (;index < ptLength-1; index++){
          verPts.push({
            position:trackPoints[index].wcPosition,
          });
          var latLng = Cartographic.fromCartesian(trackPoints[index].wcPosition);
          var projGroundPos = Cartesian3.fromRadians(latLng.longitude, latLng.latitude);
          verPts.push({
            position:projGroundPos,
          });
          vertexCount+=2;
        }
      }else{
        for (var j=0; j< trackPoints.length; j++){
          verPts.push({
            position:trackPoints[j].wcPosition,
          });
          var latLng = Cartographic.fromCartesian(trackPoints[j].wcPosition);
          var projGroundPos = Cartesian3.fromRadians(latLng.longitude, latLng.latitude);
          verPts.push({
            position:projGroundPos,
          });
          vertexCount+=2;
        }
      }
      vertexWall.push(verPts);
      indexCount +=((vertexCount-2)*3);
    }
  }

  if(vertexWall.length == 0){
    return;
  }
  var boundingSphere = new BoundingSphere();
  var indices = IndexDatatype.createTypedArray(vertexCount, indexCount);
  var position = new Float64Array(vertexCount * 3);
  var colorBuffer = new Uint8Array(vertexCount * 4);

  var positions= [];
  var ptIndex = 0;
  var rIndexNums = 0;
  for (var i=0; i<vertexWall.length; i++){
    var color = traceWalls[i].color;
    var verPts = vertexWall[i];
    var verPtLength = verPts.length;
    //创建顶点buffer
    for (var m=0; m<verPtLength; m++){
      positions.push(verPts[m].position);
      position[(rIndexNums+m)*3] =  verPts[m].position.x;
      position[(rIndexNums+m)*3+1] =verPts[m].position.y;
      position[(rIndexNums+m)*3+2] =verPts[m].position.z;

      var colorRatio = 1.0 - (verPtLength-m) / verPtLength*1.0;
      colorBuffer[(rIndexNums+m)*4] =   Color.floatToByte(color.red);
      colorBuffer[(rIndexNums+m)*4+1] = Color.floatToByte(color.green);
      colorBuffer[(rIndexNums+m)*4+2] = Color.floatToByte(color.blue);
      colorBuffer[(rIndexNums+m)*4+3] = Color.floatToByte(color.alpha * colorRatio);
    }

    //创建顶点索引
    for (var n=0; (n+3)<verPtLength; n+=2){
      indices[ptIndex++] = rIndexNums + n;
      indices[ptIndex++] = rIndexNums + n+1;
      indices[ptIndex++] = rIndexNums + n+2;

      indices[ptIndex++] = rIndexNums + n+1;
      indices[ptIndex++] = rIndexNums + n+3;
      indices[ptIndex++] = rIndexNums + n+2;
    }
    rIndexNums += verPtLength;
  }
  if(positions.length > 0){
    boundingSphere = BoundingSphere.fromPoints(positions);
  }
  //清空
  parameters.traceWalls = undefined;

  return {
    positionBuffer:position.buffer,
    colorBuffer:colorBuffer.buffer,
    indices:indices.buffer,
    boundingSphere:boundingSphere,
  };
}

export default createTaskProcessorWorker(calcTraceWallMesh);